import * as React from "react";
const SvgFiRrBrand = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-brand_svg__a)">
      <path
        fill="#062147"
        d="M22.576 12.52 13.85 3.85a3.9 3.9 0 0 0-3.22-1.09l-5.804.65L1.707.294A.999.999 0 1 0 .293 1.707l3.118 3.118-.696 6.088a3.87 3.87 0 0 0 1.136 3.062l8.713 8.645a4.8 4.8 0 0 0 3.4 1.404h.02a4.79 4.79 0 0 0 3.408-1.431l3.21-3.242a4.85 4.85 0 0 0-.025-6.832m-1.396 5.426-3.21 3.242a2.8 2.8 0 0 1-1.994.837h-.01a2.8 2.8 0 0 1-1.993-.823L5.26 12.555a1.86 1.86 0 0 1-.554-1.45l.512-4.473 1.857 1.857A2 2 0 0 0 7 9a2 2 0 1 0 2-2c-.178 0-.347.03-.512.074L6.634 5.22l4.226-.474.021-.003a1.88 1.88 0 0 1 1.56.525l8.725 8.668a2.846 2.846 0 0 1 .014 4.009m-3.974-5.151a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 0 1.414l2.5 2.5a.997.997 0 0 0 1.414 0l3-3a1 1 0 0 0 0-1.414zM16 17.588l-1.086-1.086 1.586-1.586 1.086 1.086z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-brand_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBrand;
